import {createContext} from "react";

export type SelectedPageContextType = {
    selectedUrl?: string | null;
    setSelectedUrl?: (u: string | null) => void;
}

export const SelectedPageContext = createContext<SelectedPageContextType>({});
